<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row align-items-start empresa-header-row">
      <div class="col-auto">
        <button
          type="button"
          class="empresa-logo-card"
          [class.has-logo]="logoUrlPreview"
          (click)="abrirDialogLogo()">
          @if (logoUrlPreview) {
            <img [src]="logoUrlPreview" alt="Logo da empresa" />
          } @else {
            <div class="logo-empty">
              <mat-icon>image</mat-icon>
              <small>Logo</small>
            </div>
          }
          <div class="logo-overlay">
            <mat-icon>edit</mat-icon>
          </div>
        </button>
      </div>
      <div class="col">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Informações da Empresa</h1>
            <p class="welcome-message">Consulte os dados cadastrais da empresa.</p>
          </div>
        </div>
      </div>

    </div>

    <form class="form" [formGroup]="model">
      <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

      <div class="section-container" id="info-basica">
        <div class="section-title">
          <mat-icon>store</mat-icon>
          <span>Informações Básicas</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome Empresa</mat-label>
              <input matInput formControlName="nomeEmpresa" type="text" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" type="text" [mask]="masks.cnpj" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fuso horário</mat-label>
              <mat-icon class="material-icons-outlined" matSuffix matTooltip="Fuso horário da sua localidade"
                >info_outline</mat-icon
              >
              <input matInput formControlName="listaTimezone" type="text" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome fantasia</mat-label>
              <input matInput formControlName="nomeFantasia" type="text" maxlength="100" />
              @if (model.get('nomeFantasia')?.hasError('maxlength')) {
                <mat-error>O nome fantasia deve ter no máximo 100 caracteres.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de fundação</mat-label>
              <input
                matInput
                [matDatepicker]="pickerFundacao"
                [max]="dataMaxima"
                formControlName="dataFundacao"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                (keydown)="onDataFundacaoKeydown($event)"
                (input)="onDataFundacaoInput($event)" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerFundacao"></mat-datepicker-toggle>
              <mat-datepicker #pickerFundacao></mat-datepicker>
              @if (model.get('dataFundacao')?.hasError('matDatepickerMax')) {
                <mat-error>A data de fundação não pode ser futura.</mat-error>
              }
              @if (model.get('dataFundacao')?.hasError('matDatepickerParse')
                || model.get('dataFundacao')?.hasError('dataInvalida')) {
                <mat-error>Informe uma data válida.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="section-container" id="dados-fiscais">
        <div class="section-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Dados Fiscais</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <app-select-pesquisavel
              [control]="idRegimeTributario"
              label="Regime de tributação"
              [offlineList]="listaRegimeTributario"
              idField="id"
              nameField="descricao"
              [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          @if (usaRegimeApuracao) {
            <div class="col-12 col-md-4">
              <app-select-pesquisavel
                [control]="idRegimeApuracaoIrpj"
                label="Regime de apuração"
                [offlineList]="listaRegimeApuracaoIrpj"
                idField="id"
                nameField="descricao">
              </app-select-pesquisavel>
            </div>
          }
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <app-select-pesquisavel
              [control]="idSituacaoContribuinteEmpresa"
              label="Situação da Inscrição Estadual"
              [offlineList]="listaSituacaoContribuinteEmpresa"
              idField="id"
              nameField="descricao"
              subscriptSizing="dynamic"
              [hint]="ajudaSituacaoContribuinteEmpresa">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="inscricaoEstadual" type="text" />
              @if (model.get('inscricaoEstadual')?.hasError('required')) {
                <mat-error>Informe a Inscrição Estadual.</mat-error>
              } @else {
                <mat-hint>{{ ajudaInscricaoEstadual }}</mat-hint>
              }
            </mat-form-field>
          </div>

        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNAE Principal</mat-label>
              <input matInput type="text" inputmode="numeric"
                formControlName="cnaePrincipal"
                [mask]="masks.cnae"
                placeholder="Ex: 6201-5/01" />
              <button mat-icon-button matSuffix type="button"
                aria-label="Pesquisar CNAE" matTooltip="Pesquisar CNAE"
                [disabled]="cnaePrincipal.disabled" (click)="pesquisarCnae()">
                <mat-icon class="material-symbols-outlined">search</mat-icon>
              </button>
              @if (cnaePrincipal.hasError('mask')) {
                <mat-error>Informe os 7 dígitos do CNAE.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="inscricaoMunicipal" type="text" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição SUFRAMA</mat-label>
              <input matInput formControlName="inscricaoSuframa" type="text" />
            </mat-form-field>
          </div>
        </div>

        @if (isContribuinteExclusivoIbsCbs) {
          <app-alert-card class="d-block" type="info" title="O que muda com esse enquadramento">
            <ul class="mb-0 ps-3">
              @for (restricao of frasesEnquadramentoContribuinteExclusivoIbsCbs; track restricao) {
                <li>{{ restricao }}</li>
              }
            </ul>
          </app-alert-card>
        }

        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">badge</mat-icon>
          <span>Inscrições Estaduais dos Substitutos Tributários</span>
          <div class="section-title-actions ms-auto">
            <button class="btn-section" type="button" mat-button (click)="adicionarSubstitutoTributario()">
              <mat-icon>add</mat-icon> Adicionar
            </button>
          </div>
        </div>

        <div formArrayName="listaSubstitutoTributario">
          @for (linha of listaSubstitutoTributario.controls; track linha; let i = $index) {
            <div [formGroupName]="i" class="substituto-row">
              <div class="row">
                <div class="col-10 col-lg-11">
                  <div class="row">
                    <div class="col-12 col-md-5">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="idUnidadeFederativa">
                          <mat-option [value]="null">Selecione</mat-option>
                          @for (uf of listaUnidadeFederativa; track uf.idUnidadeFederativa) {
                            <mat-option [value]="uf.idUnidadeFederativa">{{ uf.descricao }}</mat-option>
                          }
                        </mat-select>
                        @if (linha.get('idUnidadeFederativa')?.hasError('ufDuplicada')) {
                          <mat-error>UF já informada em outra linha.</mat-error>
                        }
                        @if (linha.get('idUnidadeFederativa')?.hasError('required')) {
                          <mat-error>Informe o estado.</mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <div class="col-12 col-md-7">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Inscrição Estadual</mat-label>
                        <!--
                          maxlength no atributo, e nao um Validators.maxLength: a coluna e
                          varchar(30) e `validarSubstitutosTributarios` sobrescreve os erros
                          destes controles com setErrors, o que apagaria o erro do validador.
                          O atributo trava a digitacao e a colagem; o servidor confere de novo.
                        -->
                        <input matInput formControlName="inscricaoEstadual" type="text" maxlength="30" />
                        @if (linha.get('inscricaoEstadual')?.hasError('required')) {
                          <mat-error>Informe a inscrição estadual.</mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="col-2 col-lg-1 delete-col">
                  <button
                    type="button"
                    mat-icon-button
                    (click)="removerSubstitutoTributario(i)"
                    matTooltip="Excluir">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }

          @if (listaSubstitutoTributario.length === 0) {
            <app-empty-state
              icon="badge"
              title="Nenhuma inscrição de substituto tributário cadastrada"
              subtitle="Cadastre a inscrição estadual da empresa em cada UF onde ela é substituta tributária.">
            </app-empty-state>
          }
        </div>
      </div>

      <div class="section-container" id="endereco">
        <div class="section-title">
          <mat-icon>location_on</mat-icon>
          <span>Endereço</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CEP</mat-label>
              <input matInput formControlName="cep" type="text" [mask]="masks.cep" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Logradouro</mat-label>
              <input matInput formControlName="logradouro" type="text" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número</mat-label>
              <input matInput formControlName="numero" type="text" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Complemento</mat-label>
              <input matInput formControlName="complemento" type="text" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bairro</mat-label>
              <input matInput formControlName="bairro" type="text" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>UF</mat-label>
              <input matInput formControlName="unidadeFederativa" type="text" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Município</mat-label>
              <input matInput formControlName="municipio" type="text" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isLoadingSalvar"
  [isSalvarDisabled]="isSalvarDesabilitado"
  (cancelar)="cancelar()"
  (salvar)="salvar()">
</app-footer-action>
